
<form class="document-groups" style="padding: 2em;" [formGroup]="formG1">

	<triv-input [fGroup]="formG1" [data]="myInputs.gruppenname"></triv-input>
	<triv-input [fGroup]="formG1" [data]="myInputs.gruppeBeshreibung"></triv-input>

	<div>
		<div class="aSubTitle">
			Ordner
		</div>
		<div *ngIf="!allFolders.length">
			Keine Ordner
		</div>
		<div *ngIf="allFolders.length" [formGroup]="formG2">
			<div *ngFor="let f of allFolders">
				<mat-checkbox
					[formControlName]="replaceDots(f.folderPath)">
					{{f.folderName}}
				</mat-checkbox>
			</div>
		</div>
	</div>
	
	<div style="margin-top: 4em; display: flex; flex-flow: row; justify-content: flex-end; gap: 2em;">

		<button mat-raised-button 
			*ngIf="!group.gruppenId"
			[disabled]="bSaving"
			(click)="cancel()">Abbrechen</button>

		<button mat-raised-button 
			[disabled]="formG1.pristine || bSaving"
			(click)="reset()">Zurücksetzen</button>

		<button mat-raised-button
			color="primary" 
			(click)="save()" 
			[disabled]="!formG1.valid || (formG1.pristine && formG2.pristine) || bSaving">
			Speichern</button>

	</div>

</form>
